import React from "react";
import { Link } from "react-router-dom";

const UnauthorizedPage = () => {
  return (
    <>
      <div className="d-flex justify-content-center align-items-center vh-100">
        <div className="text-center">
          <h1 className="display-1"></h1>
          <p className="lead">You are not Authorized!</p>
          <p className="lead">
            If you want to access login as Admin <Link to={"/sign-in"}>login</Link>
          </p>
          <Link className="btn btn-secondary" to="/">
            Go back
          </Link>
        </div>
      </div>
    </>
  );
};

export default UnauthorizedPage;
